import { database } from "../firebase/config";
import { doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";

export const lineupService = {
  // Get lineup for a specific night
  async getLineup(nightId, eventKey = "sanremo") {
    try {
      const docRef = doc(
        database,
        "events",
        eventKey,
        "lineups",
        String(nightId),
      );
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return docSnap.data().songs;
      }
      const legacyDocId =
        eventKey === "sanremo"
          ? `lineup_${nightId}`
          : `${eventKey}_lineup_${nightId}`;
      const legacyRef = doc(database, "system_state", legacyDocId);
      const legacySnap = await getDoc(legacyRef);
      if (legacySnap.exists()) {
        return legacySnap.data().songs;
      }
      return null;
    } catch (error) {
      console.error(`Error getting lineup for night ${nightId}:`, error);
      throw error;
    }
  },

  // Subscribe to lineup changes
  subscribeToLineup(nightId, callback, onError, eventKey = "sanremo") {
    const docRef = doc(
      database,
      "events",
      eventKey,
      "lineups",
      String(nightId),
    );
    return onSnapshot(
      docRef,
      (doc) => {
        if (doc.exists()) {
          callback(doc.data().songs);
        } else {
          callback(null);
        }
      },
      (error) => {
        console.error(`Lineup subscription error for night ${nightId}:`, error);
        if (onError) onError(error);
      },
    );
  },

  // Update lineup for a specific night
  async updateLineup(nightId, songKeys, eventKey = "sanremo") {
    try {
      const docRef = doc(
        database,
        "events",
        eventKey,
        "lineups",
        String(nightId),
      );
      await setDoc(docRef, {
        songs: songKeys,
        updatedAt: new Date().toISOString(),
      });
      return true;
    } catch (error) {
      console.error(`Error updating lineup for night ${nightId}:`, error);
      throw error;
    }
  },
};
